import styled from 'styled-components';
import { useOrderAnalysisChart } from '../chart/provider/OrderAnalysisChartProvider';
import { useEffect, useState } from 'react';

export const DashboardPageHeader = () => {
  const { data } = useOrderAnalysisChart();

  const [fixedData, setFixedData] = useState<{
    orderCount: number;
    orderAmount: number;
  } | null>(null);

  useEffect(() => {
    if (data.length !== 1) return;
    const orderCount = data[0].orderCount;
    const orderAmount = data[0].orderAmount;
    setFixedData({ orderCount: orderCount, orderAmount: orderAmount });
  }, [data]);
  return (
    <>
      <div style={{ height: '15px' }} />
      <TitleWrapper>
        <TitleLabel>이번달 주문횟수</TitleLabel>
        <TitleValue>{fixedData?.orderCount}회</TitleValue>
      </TitleWrapper>
      <div style={{ height: '15px' }} />
      <TitleWrapper>
        <TitleLabel>이번달 주문총액</TitleLabel>
        <TitleValue>{fixedData?.orderAmount.toLocaleString()}원</TitleValue>
      </TitleWrapper>
      <div style={{ height: '15px' }} />
    </>
  );
};

const TitleWrapper = styled.div`
  flex: 1;
  background-color: white;
  display: flex;
  flex-direction: row;
  gap: 30px;
  padding: 7px;
  border-radius: 3px;
`;

const TitleLabel = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.charcoal};
  align-content: center;
`;

const TitleValue = styled.div`
  font-size: 25px;
  font-weight: 700;
  align-content: center;

  color: ${({ theme }) => theme.colors.blue};
`;
